/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetExaminedDto } from './GetExaminedDto';
import {
    GetExaminedDtoFromJSON,
    GetExaminedDtoFromJSONTyped,
    GetExaminedDtoToJSON,
} from './GetExaminedDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';

/**
 * 
 * @export
 * @interface GetEmailDto
 */
export interface GetEmailDto {
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    id: string;
    /**
     * 
     * @type {GetExaminedDto}
     * @memberof GetEmailDto
     */
    examined: GetExaminedDto;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetEmailDto
     */
    user: GetUserDto;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    sentTo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    bcc?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEmailDto
     */
    sendDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    status?: GetEmailDtoStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    info?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    document?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmailDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetEmailDto
     */
    emailType?: GetEmailDtoEmailTypeEnum | null;
}


/**
 * @export
 */
export const GetEmailDtoStatusEnum = {
    NotSent: 'NotSent',
    Sent: 'Sent',
    Error: 'Error'
} as const;
export type GetEmailDtoStatusEnum = typeof GetEmailDtoStatusEnum[keyof typeof GetEmailDtoStatusEnum];

/**
 * @export
 */
export const GetEmailDtoEmailTypeEnum = {
    Orzeczenie: 'Orzeczenie',
    Orzeczenie_angielskie: 'Orzeczenie angielskie',
    Skierowanie: 'Skierowanie',
    Skierowanie_zewntrzne: 'Skierowanie zewnętrzne',
    Skierowanie_Synevo: 'Skierowanie Synevo',
    Potwierdzenie_wizyty: 'Potwierdzenie wizyty',
    Wynik_badania_psychologicznego: 'Wynik badania psychologicznego',
    Potwierdzenie_patnoci: 'Potwierdzenie płatności',
    Informacja_o_patnoci: 'Informacja o płatności',
    Badanie_uzupenienie_dokumentw: 'Badanie, uzupełnienie dokumentów',
    Zlecono_badanie_online: 'Zlecono badanie online',
    Faktura_sprzeday: 'Faktura sprzedaży',
    E_Paragon: 'E-Paragon',
    Przypomnienie_o_patnoci: 'Przypomnienie o płatności',
    Kod_weryfikacyjny_2FA: 'Kod weryfikacyjny 2FA',
    Podsumowanie_automatycznego_fakturowania: 'Podsumowanie automatycznego fakturowania',
    Anulowanie_orzeczenia: 'Anulowanie orzeczenia'
} as const;
export type GetEmailDtoEmailTypeEnum = typeof GetEmailDtoEmailTypeEnum[keyof typeof GetEmailDtoEmailTypeEnum];


/**
 * Check if a given object implements the GetEmailDto interface.
 */
export function instanceOfGetEmailDto(value: object): value is GetEmailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('examined' in value) || value['examined'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('sendDate' in value) || value['sendDate'] === undefined) return false;
    return true;
}

export function GetEmailDtoFromJSON(json: any): GetEmailDto {
    return GetEmailDtoFromJSONTyped(json, false);
}

export function GetEmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'examined': GetExaminedDtoFromJSON(json['examined']),
        'user': GetUserDtoFromJSON(json['user']),
        'sentTo': json['sentTo'] == null ? undefined : json['sentTo'],
        'bcc': json['bcc'] == null ? undefined : json['bcc'],
        'sendDate': (new Date(json['sendDate'])),
        'status': json['status'] == null ? undefined : json['status'],
        'info': json['info'] == null ? undefined : json['info'],
        'document': json['document'] == null ? undefined : json['document'],
        'active': json['active'] == null ? undefined : json['active'],
        'emailType': json['emailType'] == null ? undefined : json['emailType'],
    };
}

export function GetEmailDtoToJSON(value?: GetEmailDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'examined': GetExaminedDtoToJSON(value['examined']),
        'user': GetUserDtoToJSON(value['user']),
        'sentTo': value['sentTo'],
        'bcc': value['bcc'],
        'sendDate': ((value['sendDate']).toISOString()),
        'status': value['status'],
        'info': value['info'],
        'document': value['document'],
        'active': value['active'],
        'emailType': value['emailType'],
    };
}

